/**
 * PostureModeContext
 *
 * Delivers the active `PostureModeStrategy` to the component tree.
 *
 * Usage:
 *   <PostureModeProvider mode={SELF_ASSESSMENT_STRATEGY}>
 *     <PostureAnalysisApp />
 *   </PostureModeProvider>
 *
 * Consuming:
 *   const mode = usePostureMode();
 *   if (!mode.canSave) return;
 */

import React, { createContext, useContext, type ReactNode } from 'react';
import { PRACTITIONER_STRATEGY, type PostureModeStrategy } from './posture-mode-strategy';

const PostureModeContext = createContext<PostureModeStrategy>(PRACTITIONER_STRATEGY);

export const usePostureMode = (): PostureModeStrategy => useContext(PostureModeContext);

export interface PostureModeProviderProps {
  mode: PostureModeStrategy;
  children: ReactNode;
}

export const PostureModeProvider: React.FC<PostureModeProviderProps> = ({ mode, children }) => (
  <PostureModeContext.Provider value={mode}>
    {children}
  </PostureModeContext.Provider>
);
